import { render, staticRenderFns } from "./YogoSelect.vue?vue&type=template&id=6a686a36&scoped=true&"
import script from "./YogoSelect.vue?vue&type=script&lang=js&"
export * from "./YogoSelect.vue?vue&type=script&lang=js&"
import style0 from "./YogoSelect.vue?vue&type=style&index=0&id=6a686a36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a686a36",
  null
  
)

export default component.exports